import * as React from 'react';
import { FC } from 'react';

import PointsText from 'components/points-text';

import { RewardLockIcon } from '../reward-lock-icon';
import { RewardPointCost } from '../reward-point-cost';

import {
  PointsContainer,
  StyledPointsIcon,
  PointsText as StyledPointsText,
} from './incentive-details.styled';
import { IRewardPoints } from './types';

export const RewardPoints: FC<IRewardPoints> = ({ pointCost, locked }) => {
  return (
    <PointsContainer>
      <StyledPointsText>
        {locked ? <RewardLockIcon data-testid="reward-lock" /> : <StyledPointsIcon />}
        <RewardPointCost pointCost={pointCost}>
          {pointCost}&nbsp;
          <PointsText />
        </RewardPointCost>
      </StyledPointsText>
    </PointsContainer>
  );
};
